import { newsEventTypeSv } from './newsTranslations'
import { millistreamSectorsTranslationsSv } from './millistreamSectorsTranslations'

export const issueTypeTooltipsSv = {
    'Rights issue': 'Visa företrädesemissioner',
    IPO: 'Visa IPO',
    'Directed issue': 'Visa riktade emissioner',
    'Non-cash issue': 'Visa apportemissioner',
    Warrant: 'Visa teckningsoptioner',
    Convertible: 'Visa konvertibler',
}

/** Domain entity labels and field names. */
export const entitiesSv = {
    issue: {
        singular: 'Emission',
        plural: 'Emissioner',
        fields: {
            id: 'Id',
            shareId: 'Aktie',
            recordDate: 'Avstämningsdag',
            incRightsDate: 'Datum inkl rätter',
            exRightsDate: 'Datum exkl rätter',
            rightsStartDate: 'Rätter start handel',
            rightsEndDate: 'Rätter slut handel',
            subStartDate: 'Teckningsperiod start',
            subEndDate: 'Teckningsperiod slut',
            ipoTradingDate: 'Första handelsdag',
            outstandingShares: 'Utestående antal aktier',
            offeredUnits: 'Erbjudna units',
            rightsRequired: 'Rätter som krävs',
            unitsReceived: 'Units som erhålls',
            sharesInUnit: 'Aktier per unit',
            unitSubPrice: 'Teckningspris per unit',
            approxCommitment: 'Åtagande (ca)',
            approxGuarantor: 'Garanterat (ca)',
            overAllotmentSize: 'Övertilldelning volym',
            overAllotmentAllocation: 'Övertilldelning tilldelat',
            internalComment: 'Intern kommentar',
            externalComment: 'Extern kommentar',
            unitSubTotal: 'Units tecknade',
            unitSubWithRights: 'Units tecknade med rätter',
            unitSubWithoutRights: 'Units tecknade utan rätter',
            unitSubGuarantor: 'Units tecknade av garanter',
            unitGuaranteeFee: 'Units erhållna som arvode',
            generalMeetingDate: 'Bolagsstämma',
            isinRights: 'ISIN för rätter',
            isinUnits: 'ISIN för units',
            cancelled: 'Avbruten',
            approxTotalCommitment: 'Totalt åtagande (ca)',
            sharesRequired: 'Aktier som krävs',
            rightsReceived: 'Rätter som erhålls',
            unitPctSubWithRights: 'Units tecknade med rätter (%)',
            unitPctSubWithoutRights: 'Units tecknade utan rätter (%)',
            unitPctSubGuarantor: 'Units tecknade av garanter (%)',
        },
    },
    issueType: {
        singular: 'Emissionstyp',
        plural: 'Emissionstyper',
        earnout: 'Tilläggsköpeskilling',
        specialUnitIssue: 'Speciell unitemission',
        tooltips: issueTypeTooltipsSv,
        values: {
            'ABB Directed issue': 'Riktad emission (ABB)',
            'Directed issue': 'Riktad emission',
            'Guarantor fee issue': 'Garantiersättning',
            IPO: 'IPO',
            'Non-cash issue': 'Apportemission',
            'Rights issue': 'Företrädesemission',
            Warrant: 'Teckningsoptioner',
            Convertible: 'Konvertibler',
            reverseTakeover: 'Reverse takeover/Omvänt förvärv',
        },
    },
    warrant: {
        singular: 'Teckningsoption',
        plural: 'Teckningsoptioner',
        fields: {
            id: 'Id',
            issueId: 'Emission',
            name: 'Namn på teckningsoption',
            subStartDate: 'Teckningsperiod start',
            subEndDate: 'Teckningsperiod slut',
            vwapDiscount: 'VWAP rabatt',
            vwapDays: 'VWAP-beräkning i dagar',
            vwapPeriodEnd: 'VWAP-beräkning sista datum',
            numberOfWarrants: 'Minimum teckningskurs',
            priceMin: 'Minimum teckningskurs',
            priceMinQuota: 'Kvotvärde minimum teckningskurs',
            priceMax: 'Maximal teckningskurs',
            isinWarrant: 'ISIN för teckningsoptionen',
            warrantsRequired: 'Teckningsoptioner som krävs',
            sharesReceived: 'Aktier som erhålls',
            sharesSubscribed: 'Antal tecknade aktier',
            internalComment: 'Intern kommentar',
            externalComment: 'Extern kommentar',
            warrantsPerUnit: 'Teckningsoptioner per unit',
            commitments: 'Teckningsåtagande',
            guarantors: 'Garantiåtagande',
            warrantSubPrice: 'Teckningskurs',
        },
    },
    company: {
        singular: 'Bolag',
        plural: 'Bolag',
        fields: {
            id: 'Id',
            name: 'Namn',
            ticker: 'Ticker',
            isin: 'ISIN',
            website: 'Hemsida',
            sector: 'Sektor',
            industry: 'Bransch',
            description: 'Beskrivning',
            logo: 'Logotyp',
        },
    },
    news: {
        singular: 'Nyhet',
        plural: 'Nyheter',
        eventType: newsEventTypeSv,
        fields: {
            id: 'Id',
            title: 'Rubrik',
            content: 'Innehåll',
            date: 'Datum',
            newsType: 'Nyhetstyp',
        },
    },
    investor: {
        singular: 'Investerare',
        plural: 'Investerare',
    },
    convertible: {
        singular: 'Konvertibel',
        plural: 'Konvertibler',
        convertibleLoan: 'Konvertibellån',
        fields: {
            conversion: 'Konvertering',
            repayment: 'Återbetalning',
            offset: 'Kvittning',
            new_loan: 'Upptagning av lån',
            write_off: 'Nedskrivning',
        },
    },
    common: {
        subscriptionRate: 'Teckningsgrad',
        totalCommitmentRate: 'Säkerställandegrad',
        issueType: 'Emissionstyp',
        watchlist: 'Bevakningslista',
    },
    tableHeaders: {
        country: 'Land',
        name: 'Namn',
        sector: 'Bransch',
        marketList: 'Lista',
        marketCap: 'Börsvärde',
        latestIssue: 'Senaste emissionen',
        latestIssueDescription:
            'Datumet visar när teckningsperioden i en företrädesemission påbörjades. För övriga emissioner är datumet när emissionen först offentliggjordes.',
        issue: 'Emission',
        preMoney: 'Pre-money',
        subscriptionPrice: 'Teckningskurs (per aktie)',
        closePriceYesterday: 'Aktiekurs (igår)',
        marketCapYesterday: 'Börsvärde (igår)',
        legalAdvisors: 'Legal rådgivare',
        issuingAgents: 'Emissionsinstitut',
        discount10dVwap: 'Rabatt (10d VWAP)',
        terpDiscount10dVwap: 'TERP-Rabatt (10d VWAP)',
        dilutionMax: 'Utspädning (max)',
        dilutionActual: 'Utspädning (faktisk)',
        feeLevel1: 'Garantiersättning',
        warrants: 'Teckningsoptioner',
        noncashConsideration: 'Apportegendom',
        issueType: 'Typ',
        share: 'Aktie',
        tags: 'Taggar',
        status: 'Status',
        date: 'Datum',
        dateDescription:
            'Datumet visar sista dagen i teckningsperioden för avslutade företrädesemissioner och första handelsdagen för genomförda IPOer, annars hela teckningsperioden. För övriga emissioner är datumet när emissionen först offentliggjordes.',
        issueSector: 'Branch',
        offeredSize: 'Belopp',
        subscribedSize: 'Tecknat belopp',
        financialAdvisors: 'Fin. rådgivare',
        totalCommitment: 'Säkerställandegrad',
        outcome: 'Utfall',
        priceChange: 'Kursutveckling',
        updatedAt: 'Uppdaterad',
        selectAdvisorTypeDescription: 'Välj typ av rådgivare att visa',
        selectPriceChangePeriodDescription: 'Välj tidsperiod sedan emisson',
        postIssueMax: 'Max',
        postIssue3m: '3 månader',
        postIssue6m: '6 månader',
        postIssue12m: '12 månader',
        loanAmount: 'Lånebelopp',
        maturityDate: 'Förfallodatum',
        publicationDate: 'Publiceringsdatum',
        subStartDate: 'Första teckningsdag',
        subEndDate: 'Sista teckningsdag',
        warrantSubPrice: 'Teckningskurs',
        closePrice: 'Aktuell aktiekurs',
        warrantAmount: 'Belopp',
        countSharesSubscribed: 'Antal tecknade optioner',
        subscribedAmount: 'Tecknat belopp',
        unlisted: 'Onoterad',
    },
    millistreamSectors: millistreamSectorsTranslationsSv,
}
